// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cEoG","importantInfo":"styles_importantInfo__3V1Ii"};